var _rect, _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPontoEstratgico = function SvgPontoEstratgico(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#FFECE8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9675_14863)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1168 18.6171C43.6014 17.5402 41.5091 17.909 40.4437 19.4408C39.8391 20.3099 40.002 21.4919 40.7906 22.1642L32.5546 34.0052L31.7534 33.4358C30.541 32.5743 28.8672 32.8693 28.0149 34.0947C27.1625 35.3202 27.4544 37.012 28.6667 37.8735L35.0306 42.3958L21.3328 62.0893C20.7521 62.9242 20.9509 64.0767 21.7768 64.6637C22.6028 65.2506 23.743 65.0496 24.3237 64.2148L38.0215 44.5213L45.2131 49.6318C46.4254 50.4933 48.0992 50.1983 48.9516 48.9729C49.8039 47.7474 49.5121 46.0556 48.2997 45.194L47.5094 44.6324L55.7459 32.7907C56.6374 33.306 57.787 33.0596 58.3894 32.1935C59.4549 30.6617 59.0901 28.5469 57.5746 27.4699L45.1168 18.6171Z",
    fill: "#E76F00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9675_14863"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(17 16)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPontoEstratgico, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ponto-estratégico.914f4ccf.svg";
export { ForwardRef as ReactComponent };